








module.exports =
  props:
    tag:
      type: Tag

    deletable:
      type: Boolean
      default: false

  computed:
    style: ->
      color = "##{@tag.color}"
      {color, 'border-right-color': color}

  methods:
    removeTag: ->
      @$emit 'remove-tag', @tag





// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/tags/tag.vue